import { FstaFlagDefaults } from '@fullstory/client-api';
import { SpecObject, SpecTargetObjectType } from '@fullstory/proto/fs/services/search-settings';
import {
  BySlug,
  SpecInfo,
  SpecObjectInfo,
  toSpecObjectInfo,
  toSpecObjectMappingInfo,
} from '../modules/specs';
import { keyBy } from 'lodash';

export type TestSpecObject = {
  objectSlug: string;
  targetObjectType: SpecTargetObjectType;
  targetObjectId?: string;
};

export const createSpecObjectsForTest = (
  testSpecObjects: TestSpecObject[],
): BySlug<SpecObjectInfo> =>
  keyBy(testSpecObjects.map(createSpecObjectForTest), object => object.slug);

export const createSpecObjectForTest = (testSpecObject: TestSpecObject): SpecObjectInfo => {
  const specName = testSpecObject.objectSlug.split('/')[0] ?? 'Spec';
  const spec: SpecInfo = {
    slug: specName,
    displayName: specName,
    configurable: true,
    active: true,
  };

  const object: SpecObject = {
    slug: testSpecObject.objectSlug,
    metadata: null,
    targetObjectTypes: [testSpecObject.targetObjectType],
    properties: [],
  };

  const config = undefined;

  const mapping = testSpecObject.targetObjectId
    ? toSpecObjectMappingInfo({
        mapping: {
          objectSlug: testSpecObject.objectSlug,
          targetObjectId: testSpecObject.targetObjectId,
          targetObjectType: testSpecObject.targetObjectType,
          properties: [],
        },
        metadata: null,
        specObjectMappingRecordMetadata: {
          autosuggested: false,
        },
      })
    : undefined;

  return toSpecObjectInfo(spec, object, config, mapping, FstaFlagDefaults);
};
